import { gql } from 'graphql-request';
import { requestWithAuth } from '@/utilities/graphQLClient';

import { PORTFOLIO_FRAGMENT } from '@/hooks/portfolio/usePortfolio';

import type {
  Portfolio,
  PortfolioFragmentType,
} from '@/hooks/portfolio/usePortfolio';

export type UpdateManualHoldingInput = {
  symbol: string;
  exchangeCode: string;
  units: string;
  averagePurchasePrice: string;
};

export type QueryResponse =
  | { errors: Error[] }
  | { updateManualPortfolio: PortfolioFragmentType };

export const updateManualPortfolioQueryFn = async (payload: {
  id: Portfolio['id'];
  holdings: UpdateManualHoldingInput[];
  triggerPortfolioTimeSeriesRecalculation?: boolean;
}) => {
  const response = await requestWithAuth<QueryResponse>(
    gql`
      mutation updateManualPortfolio(
        $id: String!
        $holdings: [UpdateManualHoldingInput!]!
        $triggerPortfolioTimeSeriesRecalculation: Boolean
      ) {
        updateManualPortfolio(
          id: $id
          holdings: $holdings
          triggerPortfolioTimeSeriesRecalculation: $triggerPortfolioTimeSeriesRecalculation
        ) {
          ...portfolioFields
        }
      }
      ${PORTFOLIO_FRAGMENT}
    `,
    {
      id: payload.id,
      holdings: payload.holdings.map((holding) => ({
        ...holding,
        units: Number.parseFloat(holding.units),
        averagePurchasePrice:
          holding.averagePurchasePrice === ''
            ? null
            : Number.parseFloat(holding.averagePurchasePrice),
      })),
      triggerPortfolioTimeSeriesRecalculation:
        payload.triggerPortfolioTimeSeriesRecalculation,
    }
  );

  if ('updateManualPortfolio' in response) {
    return response.updateManualPortfolio;
  }

  const firstErrorMessage = response.errors[0]?.message;
  throw new Error(firstErrorMessage ?? 'Failed to update Holding');
};
